import React from 'react';
import {useRouter} from 'next/router'
import { ChevronLeft } from 'react-bootstrap-icons';
import classNames from 'classnames';
import styles from './BackTitle.module.scss'

const BackTitle = ({
  title, 
  wrapperStyle = {paddingRight: "20px", marginLeft: "-38px"}, 
  iconStyle,
  onClick
}) => {
  const router = useRouter()
  const onBack = () => {
    router.back()
  }
  return (
    <div className={classNames(styles.back_title_wrapper, "d-flex align-items-center my-4")}>
      <div 
        onClick={onClick ? onClick : onBack} 
        style={wrapperStyle} 
        className={classNames(styles.svg_wrapper, "cursor-pointer svg-wrapper")}
      >
        <ChevronLeft style={iconStyle || undefined} />
      </div>
      <h3 className="m-0 text-dark-blue md-text-size">{title}</h3>
    </div>
  );
};

export default BackTitle;